import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SweetScroll from 'sweet-scroll';
// ---
import Wrapper from '../../components/wrapper';
import './styles.css';
// ---
import { convertPipeToBrTag } from "../../utils";
import { getComponents } from "../utilities";
import PickerContainer from "../picker-container";
import FeatureCategoryContainer from '../feature-category-container';
import ScrollLoader from '../../components/scroll-loader';

/**
 *  Picker
 */
export default class Picker extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    categories: PropTypes.array,
    textColor: PropTypes.string,
    layout: PropTypes.string,
    thumbnail: PropTypes.bool,
    cta: PropTypes.arrayOf(PropTypes.node),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    categories: null,
    textColor: null,
    layout: null,
    thumbnail: null,
    cta: null,
  };
  
  /**
   *  filter - parent / child
   *  - child 選択時 他の child も同一グループなのをチェックする
   *  @param {string} parentName - 親名称 `first-0`
   *  @param {string} currentFilterId - 子名称 `first-0-second0`
   */
  static secondFilterContains(parentName, currentFilterId) {
    const divideCurrent = currentFilterId.split('-');
    if (divideCurrent.length !== 3) {
      return false;
    }
    const divideId = parentName.split('-');
    if (divideId.length !== 2) {
      return false;
    }
    return divideCurrent[0] === divideId[0] && divideCurrent[1] === divideId[1];
  }
  
  /**
   * second filter id name 判定します ex. `first-0-second0`
   * @param {string} currentFilterId filterId
   * @returns {boolean} true second filter id
   */
  static isSecondFilterId(currentFilterId) {
    const divideCurrent = currentFilterId.split('-');
    return divideCurrent.length === 3;
  }
  
  /**
   * first filter id name 判定します ex. `first-0`
   * @param {string} currentFilterId filterId
   * @returns {boolean} true first filter id
   */
  static isFirstFilterId(currentFilterId) {
    const divideCurrent = currentFilterId.split('-');
    return divideCurrent.length === 2;
  }
  
  constructor(props) {
    super(props);
    // ---
    /**
     * props.categories を `PickerContainer` のみ抽出し list する
     * @type {{first: Array, second: Array, concat: ?Array}}
     */
    this.containers = {
      first: [],
      second: [],
      concat: [],
    };
    this.onTitleClickCaller = this.onTitleClickCaller.bind(this);
    this.onThumbnailClickCaller = this.onThumbnailClickCaller.bind(this);
    // `getComponents` 通す
    /**
     * props.categories を {@link getComponents} を通す - props.categories 使用しない
     * @type {Array<*>}
     */
    this.categories = this.convertPropsCategories();
    // categories を filter する
    this.parseCategoriesList(this.categories);
    // ---
    this.opacityZeroClassName = PickerContainer.OPACITY_ZERO_CLASS_NAME;
    this.abortOpacityZero = this.abortOpacityZero.bind(this);
    this.state = {
      // mbWidth: false,
      currentFilterId: 'first-0',
      pickerIndex: 0,
      // for mb filter title
      filterTitle: '',
      filterSecondOpen: false,
      filterChangeOpacityClassName: this.opacityZeroClassName,
    };
    this.timer = {
      thumbnail: 0,
      titleCenter: 0,
      titleCenterSequence: 0,
    };
    /**
     * 連打対策のための thumbnail click 可能 flag
     * @type {boolean}
     */
    this.enableThumbnailClick = true;
    // this.delayTime = 532;
    // this.delayTime = 0;
    this.refFilterFirst = null;
    this.filterFirstTitles = {};
    this.onResize = this.onResize.bind(this);
    this.currentFilterId = this.state.currentFilterId;
  }
  onResize() {
    this.titleMoveCenter(this.currentFilterId);
  }
  
  // --------------------------------------------------
  /**
   * title click callback
   * - filter id が変更になったか判定し state 変更します
   * @param {string} id filterId
   * @param {number} index filterIndex
   * @param {string} title filter title
   */
  onTitleClickCaller(id, index, title) {
    // console.log('Picker.onTitleClickCaller', id, index, title, this.state.currentFilterId !== id);
    const isFirstSecondFilterId = Picker.isFirstFilterId(this.state.currentFilterId);
    const argIdIsFirst = Picker.isFirstFilterId(id);
    const currentFilterIdContainsId = Picker.secondFilterContains(id, this.state.currentFilterId);
    if (argIdIsFirst && currentFilterIdContainsId && isFirstSecondFilterId) {
      return;
    }
    // ---
    if (this.state.currentFilterId !== id) {
      this.currentFilterId = id;
      // ---
      // console.log('Picker.onTitleClickCaller do enableOpacityZero ----', Date.now());
      this.enableOpacityZero();
      // ---
      this.titleMoveCenter(id);
      // ---
      const changeState = {
        currentFilterId: id,
        pickerIndex: 0,
        filterTitle: Picker.isSecondFilterId(id) ? title: '',
        filterSecondOpen: false,
      };
      this.setState(changeState);
    }
  }
  // --------------------------------------------------
  titleMoveCenter(id) {
    const innerWidth = window.innerWidth;
    if (innerWidth >= 768 || !this.refFilterFirst) {
      return;
    }
    const component = this.filterFirstTitles[id];
    if (!component || !component.getTitleClientRect) {
      return;
    }
    const rect = component.getTitleClientRect();
    if (!rect) {
      return;
    }
    const center = innerWidth * 0.5;
    const middle = rect.left + (rect.width * 0.5);
    const scrollLeft = this.refFilterFirst.scrollLeft;
    // const subtract = middle - center;
    // const sweetScroll = new SweetScroll({
    //   horizontal: true,
    //   horizontalScroll: true,
    // }, this.refFilterFirst);
    // sweetScroll.toLeft((scrollLeft + subtract));
    clearTimeout(this.timer.titleCenter);
    clearTimeout(this.timer.titleCenterSequence);
    if (scrollLeft === 0) {
      // PC browser left: 0 だと移動できない問題
      this.timer.titleCenter = setTimeout(() => {
        this.refFilterFirst.scrollLeft = 1;
      }, 0);
      this.timer.titleCenterSequence = setTimeout(() => {
        this.sequenceTitleMoveCenter(center, middle, scrollLeft);
      }, 1);
    } else {
      this.sequenceTitleMoveCenter(center, middle, scrollLeft);
    }
  }
  sequenceTitleMoveCenter(center, middle, scrollLeft) {
    const subtract = middle - center;
    const expectMove = (scrollLeft + subtract);
    const duration = 320;
    const sweetScroll = new SweetScroll({
      duration,
      easing: 'easeOutCubic',
      horizontal: true,
      horizontalScroll: true,
      cancellable: false,
      stopPropagation: false,
    }, this.refFilterFirst);
    sweetScroll.toLeft(expectMove);
  }
  // --------------------------------------------------
  enableOpacityZero() {
    // document.body.classList.add(this.opacityZeroClassName);
    // console.log('Picker.enableOpacityZero ++++++++++++++', Date.now());
    this.setState({ filterChangeOpacityClassName: this.opacityZeroClassName });
  }
  abortOpacityZero() {
    // console.log('Picker.abortOpacityZero -----------------------------', Date.now());
    this.setState({ filterChangeOpacityClassName: '' });
  }
  // --------------------------------------------------
  /**
   * thumbnail click callback
   * @param {string} id filterId
   * @param {number} index picker index
   */
  onThumbnailClickCaller(id, index) {
    // console.log('Picker.onThumbnailClickCaller', id, index);
    // this.shouldChangeView(index);
    this.setState({ pickerIndex: index });
  }
  // /**
  //  * picker index が変更になっかを判定し state 変更します
  //  * @param {number} pickerIndex picker index
  //  */
  // shouldChangeView(pickerIndex) {
  //   // console.log('Picker.shouldChangeView', pickerIndex, this.state.pickerIndex, this.state.currentFilterId, this.state.pickerIndex !== pickerIndex);
  //   // if (this.state.pickerIndex !== pickerIndex) {
  //   //   this.setState({ pickerIndex });
  //   // }
  //   this.setState({ pickerIndex });
  // }
  
  // activateThumbnailClick() {
  //   // console.log('Picker.activateThumbnailClick +++', Date.now());
  //   this.enableThumbnailClick = true;
  // }
  //
  // abortThumbnailClick() {
  //   clearTimeout(this.timer.thumbnail);
  //   // console.log('Picker.abortThumbnailClick ---', Date.now());
  //   this.enableThumbnailClick = false;
  //   this.timer.thumbnail = setTimeout(() => {
  //     this.activateThumbnailClick();
  //   }, this.delayTime);
  // }
  
  // --------------------------------------------------

  /**
   * {@link getComponents} を通し `null` 除外します
   * @returns {Array} filter 後の categories
   */
  convertPropsCategories() {
    const { categories } = this.props;
    return Array.isArray(categories) ? getComponents(categories).filter(component => (component !== null)): [];
  }
  
  /**
   * props.categories をパースします
   * - 第一階層は `PickerContainer` のみ
   * - 第二回層は `PickerContainer` / `PickerItem` - `PickerContainer` のみに filter する
   * @param {array} categories props.categories
   */
  parseCategoriesList(categories = []) {
    const list = {
      first: [],
      second: [],
      concat: null,
    };
    categories.map((category, index) => {
      const step0 = `first-${index}`;
      // 第一階層は `PickerContainer` のみ
      list.first.push(
        {
          name: step0,
          parent: null,
          category,
        },
      );
      const components = Array.isArray(category.props.components) ? category.props.components: [];
      // 第二回層は `PickerContainer` / `PickerItem`
      // `PickerContainer` のみに filter する
      components.map((component, count) => {
        if (component.name === 'PickerContainer') {
          const step1 = `${step0}-second${count}`;
          list.second.push(
            {
              name: step1,
              parent: step0,
              category: component,
            },
          );
        }
        return component;
      });
      return category;
    });
    // parse しやすいように first / second concat する
    list.concat = [...list.first, ...list.second];
    this.containers = list;
  }
  
  /**
   * filter id が second list を持つか判定し index を返します
   * @param currentFilterID
   * @returns {{result: boolean, index: number}}
   */
  hasSecondItems(currentFilterID) {
    let index = -1;
    if (!Picker.isFirstFilterId(currentFilterID)) {
      return {result: false, index};
    }
    const {second} = this.containers;
    const result = second.some((data, i) => {
      if (data.parent === currentFilterID) {
        index = i;
        return true;
      }
      return false;
    });
    return {result, index};
  }
  
  /**
   * first filter selected - second filter exist の時は second filter first を active にするための対応
   * */
  shouldSecondFirstActivate() {
    // 選択 filter id が first で second が存在するかのチェック
    const {result, index} = this.hasSecondItems(this.state.currentFilterId);
    if (!result) {
      return;
    }
    const data = this.containers.second[index];
    if (data.name !== this.state.currentFilterId) {
      // console.log('Picker.shouldSecondFirstActivate changed', result, index, data.name, this.state.currentFilterId);
      this.setState({currentFilterId: data.name});
      return true;
    }
    return false;
  }
  
  // --------------------------------------------------
  componentDidUpdate() {
    this.shouldSecondFirstActivate();
  }
  
  componentDidMount() {
    this.shouldSecondFirstActivate();
    window.addEventListener('resize', this.onResize, false);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    // clear timer
    Object.values(this.timer).map(id => (clearTimeout(id)));
  }
  
  // --------------------------------------------------
  // thumbnail
  renderThumbnails() {
    const { currentFilterId } = this.state;
    // @type {array} filter id に該当する `PickerContainer` を探す
    const current = this.containers.concat.filter(data => (data.name === currentFilterId));
    // console.log('Picker.renderThumbnails - parent', currentFilterId, divided, current);
    if (!current.length) {
      return null;
    }
    // ---
    // 配列から data を取り出す
    const data = current.shift();
    const divided = currentFilterId.split('-');
    const [keyName, parentIndex, childIndex] = divided;
    const component = data.category;
    const { pickerIndex, filterChangeOpacityClassName } = this.state;
    const num = pickerIndex < 0 ? 0: parseInt(pickerIndex, 10);
    // ---
    const props = Object.assign({}, component.props);
    // console.log(`Picker.renderThumbnails - filterChangeOpacityClassName: [${filterChangeOpacityClassName}]`, currentFilterId, Date.now());
    return (
      <PickerContainer
        {...props}
        showTitle={false}
        currentFilterId={currentFilterId}
        filterId={currentFilterId}
        filterIndex={parseInt(parentIndex, 10)}
        currentPickerIndex={num}
        thumbnailClickCaller={this.onThumbnailClickCaller}
        // filterChangeOpacityClassName={filterChangeOpacityClassName}
        abortOpacityZero={this.abortOpacityZero}
      />
    );
  }
  
  // --------------------------------------------------
  // filter
  /**
   * 第一階層 filter
   * */
  renderFilterFirst() {
    const { first } = this.containers;
    const firstTitles = first.filter(data => (!!data.category.props.title));
    if (!firstTitles.length) {
      return null;
    }
    if (!first.length) {
      return null;
    }
    const { currentFilterId } = this.state;
    this.filterFirstTitles = {};
    return (
      <div
        className="Picker__filter__first"
        ref={component => (this.refFilterFirst = component)}
      >
        <div className="Picker__filter__first__title__wrap">
          {
            firstTitles.map((data, index) => {
              const component = data.category;
              // console.log('Picker.renderFilterFirst', id, result);
              const id = data.name;
              const { result } = this.hasSecondItems(id);
              const props = Object.assign({}, component.props);
              return (
                <PickerContainer
                  key={id}
                  {...props}
                  showTitle
                  currentFilterId={currentFilterId}
                  filterId={id}
                  filterIndex={index}
                  titleClickCaller={this.onTitleClickCaller}
                  hasSecond={result}
                  ref={component => (this.filterFirstTitles[id] = component)}
                />
              );
            })
          }
        </div>
      </div>
    );
  }
  
  /**
   * 第二階層 filter - PC
   * */
  renderFilterSecondPc() {
    const {second} = this.containers;
    const {currentFilterId} = this.state;
    // console.log('Picker.renderFilterSecondPc', currentFilterId, second);
    const filtered = second
      .filter(data => (data.parent === currentFilterId || data.name === currentFilterId || Picker.secondFilterContains(data.parent, currentFilterId)))
      // title 不正値除く
      .filter(data => (!!data.category.props.title));
    if (!filtered.length) {
      return null;
    }
    return (
      <div className="Picker__filter__second-pc">
        {
          filtered.map((data, index) => {
            const component = data.category;
            const id = data.name;
            const props = Object.assign({}, component.props);
            return (
              <PickerContainer
                key={id}
                {...props}
                showTitle
                currentFilterId={currentFilterId}
                filterId={id}
                filterIndex={index}
                titleClickCaller={this.onTitleClickCaller}
                parentFilter={data.parent}
              />
            );
          })
        }
      </div>
    );
  }
  
  /**
   * 第二階層 filter - MB
   * */
  renderFilterSecondMb() {
    const {second} = this.containers;
    const {
      currentFilterId,
      filterTitle,
      filterSecondOpen,
    } = this.state;
    // ---
    const filtered = second.filter(data => (data.parent === currentFilterId || data.name === currentFilterId || Picker.secondFilterContains(data.parent, currentFilterId)))
    // title 不正値除く
      .filter(data => (!!data.category.props.title));
    if (!filtered.length) {
      return null;
    }
    const openedClass = filterSecondOpen ? 'Picker__filter__second__opened' : '';
    // console.log('Picker.renderFilterSecondMb', second, filterTitle, filtered[0].category.props.title);
    const filterSelectedTitle = filterTitle || filtered[0].category.props.title || '';
    return (
      <div className={`Picker__filter__second-mb ${openedClass}`}>
        <div className="Picker__filter__second__heading">
          <div
            className="Picker__filter__second__heading__title__set"
            dangerouslySetInnerHTML={{__html: convertPipeToBrTag(filterSelectedTitle)}}
          />
          {
            (filtered.length > 1) ?
              <button
                className="Picker__filter__second__heading__btn"
                type="button"
                onClick={(event) => {
                  event.preventDefault();
                  const opposite = !filterSecondOpen;
                  this.setState({filterSecondOpen: opposite});
                }}
              /> :
              <span className="Picker__filter__second__heading__btn__margin" />
          }

        </div>
        <div className="Picker__filter__second__title__list">
          <div className="Picker__filter__second__title__wrap">
            {
              filtered.map((data, index) => {
                const component = data.category;
                const id = data.name;
                const props = Object.assign({}, component.props);
                return (
                  <PickerContainer
                    key={id}
                    {...props}
                    showTitle
                    currentFilterId={currentFilterId}
                    filterId={id}
                    filterIndex={index}
                    titleClickCaller={this.onTitleClickCaller}
                    parentFilter={data.parent}
                  />
                );
              })
            }
          </div>
          <button
            className="Picker__filter__second__title__list__btn__close"
            type="button"
            onClick={(event) => {
              event.preventDefault();
              this.setState({filterSecondOpen: false});
            }}
          />
        </div>
      </div>
    );
  }
  
  /**
   * filter out put
   * @returns {React.Element} `div.filter__seconds__root`
   * */
  renderFilterSecond() {
    const pc = this.renderFilterSecondPc();
    const mb = this.renderFilterSecondMb();
    if (!pc && !mb) {
      return null;
    }
    return (
      <div className="filter__seconds__root">
        {pc}
        {mb}
      </div>
    );
  }
  
  // --------------------------------------------------
  /**
   * filter out put - 階層数を class 末尾に付与します `Picker__filter__line1`
   * @returns {React.Element} `div.Picker__filter`
   * */
  renderFilters() {
    const filterFirst = this.renderFilterFirst();
    const filterSecond = this.renderFilterSecond();
    if (!filterFirst && !filterSecond) {
      return null;
    }
    // const line = second.length > 0 ? 2 : 1;
    return (
      <div className="Picker__filter">
        {filterFirst}
        {filterSecond}
      </div>
    );
  }
  
  // --------------------------------------------------
  renderCta() {
    const {cta} = this.props;
    if (!Array.isArray(cta) || !cta.length) {
      return null;
    }
    // ---
    return (
      <div className="Picker__cta">
        {cta}
      </div>
    );
  }
  
  // --------------------------------------------------
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      textColor,
      layout,
      thumbnail,
    } = this.props;
    // ---
    // const categories = this.convertPropsCategories();
    const categories = this.categories;
    // console.log('Picker.render', this.state);
    if (!categories.length) {
      return null;
    }
    // ---
    const textColorClass = `textColor__${(textColor || 'Dark').toLowerCase()}`;
    const layoutClass = `layout__${(layout || 'Article').toLowerCase()}`;
    const thumbnailClass = thumbnail ? '': 'thumbnail__hide';
    const { filterChangeOpacityClassName } = this.state;
    // ---
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <ScrollLoader>
          <div className={`Picker ${textColorClass} ${layoutClass} ${thumbnailClass} ${filterChangeOpacityClassName}`}>
            {this.renderFilters()}
            {this.renderThumbnails()}
            {/* CTA */}
            {this.renderCta()}
          </div>
        </ScrollLoader>
      </Wrapper>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/picker/index.jsx